// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"232":"printing","594":"about","765":"crm","966":"login"}[chunkId] || chunkId) + "." + {"196":"b3b15259","197":"9b25d524","232":"48bd9f93","594":"3e640a1d","761":"c537879c","765":"68a6d330","960":"ad654edf","966":"f670c424"}[chunkId] + ".js";
};